module.exports = { "default": require("core-js/library/fn/promise"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/vue2-google-maps/~/babel-runtime/core-js/promise.js
// module id = ./node_modules/vue2-google-maps/node_modules/babel-runtime/core-js/promise.js
// module chunks = 0